export default "__VITE_PUBLIC_ASSET__3fd75f46__"